import WaitingList from "./WaitingList";
import ScheduleAppointment from "./ScheduleAppointment";
import { useState } from 'react';

const Appointments = () => {
  const [patientData, setPatientData] = useState([]);
  const [waitingData, setWaitingData] = useState([]);

  const updatePatientData = (updatedData) => {
    setPatientData(updatedData);
  };
  const getWaitingListData = (data) => {
    setWaitingData(data);
  };
  return (
    <div className="appointments-page-container">
      <ScheduleAppointment updatePatientData={updatePatientData} waitingList={waitingData} />
      <div className="mt-2">
        <WaitingList patientData={patientData} getWaitingList={getWaitingListData} />
      </div>
    </div>
  );
};

export default Appointments;